
import import_svg from "../../../assets/images/svg/upload-data.svg";

export const importCards = [
    {
        "title": "Import",
        "description": `Import students, applications, institutes, courses information into system.`,
        "btnText": "Start an import",
        "svg": import_svg
    }
]